export { FaroRoute } from './FaroRoute';

export {
  createReactRouterV4Options,
  createReactRouterV5Options,
  initializeReactRouterV4V5Instrumentation,
} from './initialize';

export { setReactRouterV4V5SSRDependencies } from './routerDependencies';

export type { ReactRouterV4V5ActiveEvent, ReactRouterV4V5Dependencies, ReactRouterV4V5RouteShape } from './types';
